import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import {
    AvailableCoordination,
    SelectCoordinations,
    SelectCoordinationsMilestone
} from './model';

import {
    BerthStayDurationText,
    MetroMapFrameworkView,
    MilestoneHeaderRow,
    MilestoneScheduleDetailsRow
} from 'portcall/metromapframework/view';

export const SelectCoordinationsView = SuperCritical(({ model: m } : { model : SelectCoordinations }) =>
    <div className="selectcoordinations">
        <MetroMapFrameworkView
            model={m.Framework}
            ctrl={{ milestoneContent: m => <MilestoneContent milestone={m} /> }}
        />
    </div>
);

const MilestoneContent = SuperCritical(({ milestone: m } : { milestone : SelectCoordinationsMilestone }) =>
    <div>
        <MilestoneHeaderRow milestone={m} />
        <MilestoneScheduleDetailsRow milestone={m} />
        <MilestoneCoordinationsRow milestone={m} />
    </div>
);

const MilestoneCoordinationsRow = SuperCritical(({ milestone: m } : { milestone : SelectCoordinationsMilestone }) =>
    <div className="portcall-milestone-row portcall-milestone__coordinations-row">
        <MilestoneCoordinationsRowLabel milestone={m} />
        <MilestoneCoordinationsRowBody milestone={m} />
    </div>
);

const MilestoneCoordinationsRowLabel = SuperCritical(({ milestone: m } : { milestone : SelectCoordinationsMilestone }) =>
    <div className="portcall-milestone-row-label">
        {m.Date.IsBerthArrivalDate() && BerthStayDurationText(m)}
    </div>
);

const MilestoneCoordinationsRowBody = SuperCritical(({ milestone: m } : { milestone : SelectCoordinationsMilestone }) =>
    <div className="portcall-milestone-row-body">
        {m.AvailableCoordinations().map(c =>
            <AvailableCoordinationView coordination={c} key={c.Coordination.Coordination.Id()} />
        )}
    </div>
);

const AvailableCoordinationView = SuperCritical(({ coordination: c } : { coordination : AvailableCoordination }) =>
    <div className="available-coordination">
        <AvailableCoordinationSelector coordination={c} />
        <div className="available-coordination-info">
            <AvailableCoordinationTitleRow coordination={c} />
            <div className="available-coordination-descr-row pc-text-smalllabel">
                {c.Coordination.Coordination.Description()}
            </div>
        </div>
    </div>
);

const AvailableCoordinationSelector = SuperCritical(({ coordination: c } : { coordination : AvailableCoordination }) =>
    <div className="available-coordination-selector">
        <label className="pc-option">
            <input
                className="pc-breaker-input"
                type="radio"
                checked={c.State().selected}
                onChange={e => e.currentTarget.checked ? c.Request() : c.CancelRequest()}
            />
            <span className="pc-breaker-light" />
            <span className="pc-option-label">{c.Coordination.Coordination.IsMandatory() ? 'Required' : 'Yes'}</span>
        </label>
        {!c.Coordination.Coordination.IsMandatory() &&
            <label className="pc-option">
                <input
                    className="pc-breaker-input"
                    type="radio"
                    checked={!c.State().selected}
                    onChange={e => e.currentTarget.checked ? c.CancelRequest() : c.Request()}
                />
                <span className="pc-breaker-light" />
                <span className="pc-option-label">No</span>
            </label>
        }
    </div>
);

const AvailableCoordinationTitleRow = SuperCritical(({ coordination: c } : { coordination : AvailableCoordination }) => {
    const s = c.State();
    return (
        <div className="available-coordination-title-row">
            <span className="available-coordination-title">
                {c.Coordination.Coordination.Title()}
            </span>
            <span className="available-coordination-title-separator">|</span>
            {s.selected ?
                c.Coordination.AvailableProviders().length === 1 ?
                    <span className="available-coordination-provider-readonly">
                        {c.Coordination.AvailableProviders()[0].Provider.Provider()?.Name()}
                    </span> :
                    <select
                        className="available-coordination-provider-dropdown"
                        value={s.data?.ProviderId ?? 'no-provider'}
                        onChange={e => e.currentTarget.value !== 'no-provider' && c.Request(+e.currentTarget.value)}
                    >
                        {!s.data &&
                            <option value="no-provider" disabled>Select Provider</option>
                        }
                        {c.Coordination.AvailableProviders().map(p =>
                            <option value={p.Provider.ProviderId()} key={p.Provider.ProviderId()}>
                                {p.Provider.Provider()?.Name()}
                            </option>
                        )}
                    </select> :
                <span className="available-coordination-agent-prompt">
                    {c.Coordination.Coordination.AgentPrompt()}
                </span>
            }
        </div>
    );
});



// WEBPACK FOOTER //
// ./apps/portcall/selectcoordinations/view.tsx